import Forms from './../../utils/forms/forms';
import { mapGetters } from 'vuex';
import businessDayService from './../../services/businessDay';
import businessHourService from './../../services/businessHour';

export default {
  data() {
    return {
      form: new Forms({
        businessDays: {
          value: [],
          type: 'select',
        },
        start: {
          value: '',
          type: 'time',
        },
        end: {
          value: '',
          type: 'time',
        },
      }),
    };
  },

  computed: {
    ...mapGetters({
      days: 'businessDays',
      hours: 'businessHours',
    }),
  },

  watch: {
    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} days    The business days.
     */
    days(days) {
      this.form.setOptions('businessDays', days.map(d => (
        { id: d.id, name: d.day }
      )));
    },
  },

  mounted() {
    businessDayService.all();
    businessHourService.all();
    this.form.setExtraAttr('businessDays', {
      multiple: true,
    });
  },

  methods: {
    onFormChange(name, value) {
      this.form.clearSuccess(name, value);
      this.form.clearErrors(name);
      this.form[name] = value;
      this.$forceUpdate();
    },

    save() {
      this.form.loading = true;
      return businessHourService.store(this.form.data())
      .then(() => {
        this.form.loading = false;
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
        const errorsKeys = Object.keys(this.form.errors.errors);
        this.$message({
          showClose: true,
          message: errors[errorsKeys[0]][0],
          type: 'error',
        });
      });
    },

    destroy(id) {
      this.destroyLoading = true;
      businessHourService.destroy(id)
      .then(() => {
        this.destroyLoading = false;
      }).catch(() => {
        this.destroyLoading = false;
      });
    },
  },

  components: {
    VFormTable: require('./../formTable/formTable.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/openHours/openHours.js